import React, {useContext, useState} from 'react';
import { BrowserRouter as  Link } from 'react-router-dom'
import { AuthContext } from "../../../Auth.js"
import { Button, Modal, Dropdown, Icon, Message } from 'semantic-ui-react'
import InventarioTools from '../../Productos/Componentes/editarInventario'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';

export const OrdenLista =({filtro})=>{
    const { currentUser } = useContext(AuthContext)
    const [userName] = useState(currentUser.name)
    const [userRol] = useState(currentUser.rol)
    return (
        <section>
            <ListaOrdenes userName={userName} userRol={userRol} filtro={filtro}/>
        </section>
    )
}

class ListaOrdenes extends React.Component{
    constructor(props){
        super(props)
        this.state={
            empleado:this.props.userName,
            empRol:this.props.userRol,
            listaProductos:[],
            status:this.props.filtro,
            guardado: false,
            almacen: ''
        }
        this.unsubscribe=null
    }
    componentDidMount() {
        this.GetData()
        const firestore = firebase.firestore();
        const docRef = firestore.collection('Info').doc('info');

        docRef.get().then((doc) => {
        if (doc.exists) {
            this.setState({ almacen: doc.data().almPrincipal });
        } else {
            console.log('No such document!');
        }
        }).catch((error) => {
        console.log('Error getting document:', error);
        });
    }
    setReference=()=>{
        let dbReference=firebase.firestore().collection('OrdenCompra')
        dbReference=this.filterByStatus(dbReference)
        return dbReference
    }
    filterByStatus=dbReference=>{
        if(this.state.status==='all') return dbReference
        return dbReference.where('status', '==', this.state.status)   
    }
    statusCerrado=(ordenId)=>{
		const data=this.setReference().doc(ordenId)
		data.update({status: 'cerrado'})
    }
    guardarDatos=(datos, ordenId, pendientes)=>{
		const data=this.setReference().doc(ordenId)
		data.update({products: datos, pendientes: pendientes})
        //window.location.reload(false);
    }
    GetData=()=>{
		this.unsubscribe=this.setReference().orderBy('fechaCreado','desc').onSnapshot(datos=>{
            try{
                const datosArray=[]
                let blockIndex=-1
                for(let i=0; i<datos.size;i++){
                    const dato=datos.docs[i]
                    const ordenId=datos.docs[i].id
                    if(datosArray.length===0 || datosArray[blockIndex].ordenId!==ordenId){
                        datosArray.push({
                            ordenId:ordenId, 
                            requestedBy:dato.data().requestedBy,
                            requestedTo:dato.data().requestedTo,
                            status:dato.data().status,
                            productos:dato.data().products,
                            pendientes:dato.data().pendientes,
                            fechaCreado:dato.data().fechaCreado,
                            urgente:dato.data().urgente,
                        })
                        blockIndex++
                    }
                }
                this.setState({
                    listaProductos:datosArray,
                })
            }
            catch(e){
                console.log(e)
            }
        })
    }

    render(){
        return(
            <section>
                {
                this.state.listaProductos.map((data,i) => { 
                return (
                <Productos 
                    key={i}
                    empRol={this.state.empRol}
                    pendientes={data.pendientes}
                    productos={data.productos} 
                    ordenId={data.ordenId}
                    requestedBy={data.requestedBy}
                    requestedTo={data.requestedTo}
                    fechaCreado={data.fechaCreado}
                    urgente={data.urgente}
                    status={data.status}
                    guardarDatos={this.guardarDatos}
                    statusCerrado={this.statusCerrado}
                />
                )
                })
                }
            </section>
        )
    }
}

class Productos extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            empRol: props.empRol,
            ordenId: props.ordenId,
            pendientes: props.pendientes,
            requestedBy: props.requestedBy,
            requestedTo: props.requestedTo,
            fechaCreado: props.fechaCreado,
            status: props.status,
            productos: props.productos,
            urgente: props.urgente,
            tableVisible: false,
            useModal: false,
            modalKey: 0,
            nuevosDatos: props.productos,
            enInventario: 0,
            almacen: ''
        }
    }
    toggleTable = () => {
        this.setState({
            tableVisible: !this.state.tableVisible
        })
    }
    guardarDatos = () => {
        if(this.state.nuevosDatos.length > 0){
            this.props.guardarDatos(this.state.nuevosDatos, this.state.ordenId, this.state.pendientes)
            this.setState({productos: this.state.nuevosDatos}, alert("Datos Guardados"))
        } else {
            alert("Error, No Datos Nuevos")
        }
	}
    cambiarStatus = (prodID) =>{
        const statusOptions = [
            { text: 'EnvioProveedor', value: 'EnvioProveedor'},
            { text: 'RecogerVale', value: 'RecogerVale' },
            { text: 'PedidoListo', value: 'PedidoListo' },
            { text: 'PagoPendiente', value: 'PagoPendiente' },
        ]
        return (
            <Dropdown
            placeholder="Cambiar"
            selection
            options={statusOptions}
            onChange={(e, {value}) => this.statusNew(value, prodID)}
            />
        )
    }
    statusNew = (value, prodID) =>{
        let items = [...this.state.nuevosDatos];
        let item = {...items[prodID]};
        item.status = value;
        item.fecha = new Date();
        items[prodID] = item;
        this.setState({nuevosDatos: items});
    }
    statusRecibido = (key) =>{
        try{
            let preValue = this.state.nuevosDatos[key].enEnvio
            let items = [...this.state.nuevosDatos];
            let item = {...items[key]};
            if(this.state.nuevosDatos[key].entregadas){
                item.entregadas = parseFloat(preValue) + parseFloat(this.state.nuevosDatos[key].entregadas)
            }else{item.entregadas = parseFloat(preValue)}
            item.enEnvio = 0;
            item.fecha = new Date();
            if(item.entregadas >= item.quantity){
                item.status = 'Completado';
            }else{
                item.status = 'Entregado';
            }
            items[key] = item;
            var contador = this.state.pendientes
            if (items[key].quantity <= items[key].entregadas){
                contador = this.state.pendientes - 1
            }
            InventarioTools.mover(this.state.almacen,this.state.requestedTo,item.product,parseFloat(preValue),item.unidades).then(
            this.setState({nuevosDatos: items, pendientes: contador, dbUpdate:true}, 
                function() {this.guardarDatos()}
            ));
        }
        catch (e) {
            console.log(e)
            alert("Error: "+e)
        }
    }
    statusCerrado = () =>{
        this.props.statusCerrado(this.state.ordenId);
    }
    statusEnviado = (e) =>{
        let preValue = this.state.productos[e.target.id].enEnvio
        let items = [...this.state.nuevosDatos];
        let item = {...items[e.target.id]};
        if (preValue === undefined){
            item.enEnvio = e.target.value;
        } else{
            if(e.target.value > this.state.enInventario[1]){
                item.status = "Error"
            } else{
                item.enEnvio = parseFloat(preValue) + parseFloat(e.target.value);
                item.status = "En Envio"
            }
            
        }
        items[e.target.id] = item;
        this.setState({nuevosDatos: items});
    }
    enviarModal = (key, activity) =>{
        this.setState({useModal:true, modalKey: key})
        this.getCantidad(activity)
    }
    changeUsModal=(open)=>{
        this.setState({useModal:open})
	}
    getCantidad = (activity) =>{
        let nombre = activity.product.split(" / ")
        firebase.firestore().collection("Inventario")
        .where("ubicacion", "==", this.state.almacen).where("nombre", "==", nombre[0])
        .onSnapshot( async snap =>{
            if (!snap.docs[0]){
                this.setState({useModal:false})
                alert("Este producto no existe. Favor de ingresar la compra")
            } else {
                const nombre =snap.docs[0].data().nombre
                const cantidad =snap.docs[0].data().enInventario
                const unidades =snap.docs[0].data().unidades
                this.setState({
                    enInventario: [nombre, cantidad, unidades]
                })
            }
        },
        (error) => {
          console.log(error)
        })
    }
    botonCerrar = () =>{
        if(this.state.empRol === 'admin' && this.state.pendientes === 0 && this.state.status === "pendingApproval"){
            return (<button onClick={() => this.statusCerrado()}>Completar</button>)
        }
    }
    botonGuardar = () =>{
        if(this.state.productos !== this.state.nuevosDatos){
            return (<button onClick={() => this.guardarDatos()}>Guardar</button>)
        }
    }
    botonesAct = (activity, key) => {
        if(this.state.pendientes > 0){
            if(activity.status === "Completado" || activity.status === "Cancelado"){
                return(<td></td>)
            }else if(activity.status === "PedidoListo"){
                if (this.state.empRol === 'admin' || this.state.empRol === 'productPurchase'){
                    return(<td><Button onClick={() => this.enviarModal(key, activity)}>Enviar</Button></td>)
                }
            }else if(activity.status === "En Envio"){
                if (this.state.empRol === 'admin' || this.state.empRol === 'warehouse' || this.state.empRol === 'warehouseAdmin'){
                    return(<td><Button onClick={() => this.statusRecibido(key)}>Recibido</Button></td>)
                }
            }else {
                if (this.state.empRol === 'admin' || this.state.empRol === 'productPurchase'){
                    return(<td>{this.cambiarStatus(key)}</td>)
                }
            }
        }
    }
    cancelarProducto = (activity, key) => {
        if (this.state.empRol === "admin" || this.state.empRol === "office"){
            return(
                <Button color='red' floated='right' onClick={
                    () =>{
                        const confirmBox = window.confirm(`No se puede revertir!!! Desea borrar ${activity.product} de la orden de compra?`)
                        if (confirmBox === true) {
                            let items = [...this.state.nuevosDatos];
                            let item = {...items[key]};
                            item.fecha = new Date();
                            item.status = 'Cancelado';
                            items[key] = item;
                            var contador =  this.state.pendientes - 1
                            this.setState({nuevosDatos: items, pendientes: contador}, 
                                function() {this.guardarDatos()}
                            )
                        }
                    }
                    }>X
                </Button>
            )
        }
    }
    renderProductos = (productos) => {
        return (
            <>
            <div className="tabla">
                <table><tbody>
                        <tr>
                            <th>Producto</th>
                            <th>Pedido</th>
                            <th>En Envio</th>
                            <th>Entregadas</th>
                            <th>Estado</th>
                        </tr>
                        {productos.map((activity, key) =>
                            <tr key={key}>
                                <td>{activity.product}</td>
                                <td>{activity.quantity} {activity.unidades}</td>
                                <td>{activity.enEnvio}</td>
                                <td>{activity.entregadas}</td>
                                <td>{activity.status}</td>
                                {this.botonesAct(activity, key)}
                                {activity.status !== "Completado" && activity.status !== "Cancelado"?
                                    <td>{this.cancelarProducto(activity, key)}</td>
                                : null}
                            </tr>
                        )}
                </tbody></table>
                </div>
            </>
        )
    }
  setUrgente =()=>{
      if(this.state.urgente === true){
          return({backgroundColor: "orangered"}) 
      }
  }
  botonModalEnviar =(key)=>{
    if(this.state.nuevosDatos[key].status === "Error"){
        return(
            <button disabled onClick={() => this.changeUsModal(false)}>
                <Icon name='checkmark' /> Confirmar
            </button>
        ) 
        }else{
            return(
                <Button onClick={() => this.changeUsModal(false)}>
                    <Icon name='checkmark' /> Confirmar
                </Button>
            ) 
        }
  }
  faltaProducto =(key)=>{
    if(this.state.nuevosDatos[key].status === "Error"){
        return(
            <Message >No hay suficiente producto <Button><Link to={"./Compras"}>Agregar Producto Comprado</Link></Button></Message>
        ) 
    }
  }
    render() {
        return (
            <div >
                <div className={"divrowH"} onClick={this.toggleTable} style={this.setUrgente()}>
                    <p>
                    <span>Por: {this.state.requestedBy}</span>
                    <span>Enviar a: {this.state.requestedTo}</span>
                    <span>Faltan: {this.state.pendientes}</span>
                    <span>{this.state.fechaCreado.toDate().toLocaleDateString()}</span>
                    {this.botonGuardar()}
                    {this.botonCerrar()}
                    </p>
                    
                </div>
                {
                    this.state.tableVisible
                        ? this.props.productos.length > 0
                            ? this.renderProductos(this.state.nuevosDatos)
                            : null
                        : null
                }
                <Modal 
                    onClose={() => this.changeUsModal(false)}
                    onOpen={() => this.changeUsModal(true)}
                    open={this.state.useModal}>
                        <Modal.Header>
                            Enviar Producto: {this.state.productos[this.state.modalKey].product}
                        </Modal.Header>
                        <Modal.Content>
                        <div className="input">
                            <label>Cantidad:</label> 
                            <input type='number' 
                                id={this.state.modalKey} 
                                name={this.state.modalKey} 
                                required={true} 
                                onChange={this.statusEnviado}
                            />
                            <label> En Inventario: {this.state.enInventario[1] + " " + this.state.enInventario[2]} </label>
                            {this.faltaProducto(this.state.modalKey)}
                        </div>
                        </Modal.Content>
                        <Modal.Actions>
                            {this.botonModalEnviar(this.state.modalKey)}
                        </Modal.Actions>
                    </Modal>
            </div>
        )
    }
}